import * as React from 'react';
import { IVehicle } from '../../../../../../data/api/models';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import {
  isRequired,
  normalizeCurrency,
  normalizeYear,
  isNotShorterThan,
} from '../../../../../../util/validators';
import SelectControl from '../../../../../../components/SelectControl';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import * as moment from 'moment';

interface IVehicleProps {
  index: number;
  vehicle: IVehicle;
  bodyTypes: any;
  name: string;
  dispatch: any;
  change: any;
  renderDefinition: any;
}

class Vehicle extends React.Component<IVehicleProps> {
  public componentWillReceiveProps(nextProps) {
    const { vehicle, dispatch, change, name } = this.props;
    const newYear = nextProps.vehicle.year;

    // set vehicle age
    if (newYear && newYear !== vehicle.year && newYear.length === 4) {
      let age = '0';
      const currentYear = parseInt(moment().format('YYYY'), 10);
      const diff = currentYear - newYear;
      if (diff < 4) {
        age = '0';
      } else if (diff <= 10) {
        age = '10';
      } else if (diff <= 20) {
        age = '20';
      } else {
        age = '27';
      }
      dispatch(change(name + '.age', age));
    }
  }

  public render() {
    const { index, bodyTypes, renderDefinition } = this.props;
    return (
      <div className="sub-title">
        <h3>Agricultural Vehicle {index + 1}</h3>
        <div className="vehicle-box">
          <div className="quick-vehicle-body">
            <div className="quick-vehicle-icon">
              <img src={require('../../../../img/vehicle.svg')} alt="" />
            </div>
            <div className="quick-vehicle-content">
              <FormGroup controlId={'vehicle.body_type'}>
                <Col className="vehicle-questions" sm={8}>
                  What is the body type of your vehicle?
                </Col>
                <Col sm={4}>
                  <div className="full-name-fields">
                    <Row>
                      <Col sm={12}>
                        <Field
                          type="text"
                          name={'vehicles[' + index + '].bodyType'}
                          component={SelectControl}
                          validate={[ isRequired ]}
                          options={bodyTypes}
                          placeholder="Please Select"
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </FormGroup>
              {this.props.vehicle.bodyType && (
                <FormGroup controlId={'vehicle.year'}>
                  <Col className="vehicle-questions" sm={8}>
                    What is the vehicle year of make?
                  </Col>
                  <Col sm={4}>
                    <Field
                      name={'vehicles[' + index + '].year'}
                      component={FieldFormControl}
                      normalize={normalizeYear}
                      validate={[
                        isRequired,
                        isNotShorterThan(3, 'Please enter a valid year'),
                      ]}
                      placeholder="YYYY"
                    />
                  </Col>
                </FormGroup>
              )}
              {this.props.vehicle.year && (
                <FormGroup controlId={'vehicle.value'}>
                  <Col className="vehicle-questions" sm={8}>
                    {renderDefinition('b2c_vehicle_value')}
                    What is the value of this vehicle?
                  </Col>
                  <Col sm={4} className="no-padding-left">
                    <Field
                      addOn={'£'}
                      addOnClassName={['input-group-vehicle-value']}
                      currency={true}
                      type="inputGroup"
                      name={'vehicles[' + index + '].value'}
                      normalize={normalizeCurrency}
                      component={FieldFormControl}
                      validate={[ isRequired ]}
                      placeholder="0"
                    />
                  </Col>
                </FormGroup>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Vehicle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Vehicles/components/Vehicle/index.tsx